// extracted by mini-css-extract-plugin
module.exports = {"ReservePage__action":"ReservePage_ReservePage__action__35KpD","ReservePage__actions":"ReservePage_ReservePage__actions__2Af4Q"};